import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { claimRewards } from './claim';
import { rewardDataService } from './claim-data.service';
import { Router, ActivatedRoute } from "@angular/router";
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalService } from '../model/global.service';

@Component({
    selector: 'app-reward',
    templateUrl: './claimReward.html',
    animations:
        [
            trigger('triggerBackgroundChange1',
                [
                    state('one', style({ 'font-size': '15px', 'color': 'brown' })),
                    state('two', style({ 'font-size': '17px', 'color': 'yellow' })),
                    transition('* => *', animate(500))
                ]),
            trigger('triggerBackgroundChange',
                [
                    state('first', style({ 'background-color': 'orange', 'width': '120px' })),
                    state('second', style({ 'background-color': 'brown', 'width': '130px' })),
                    transition('* => *', animate(1000))
                ]),
            trigger('simpleFadeAnimation', [

                // the "in" style determines the "resting" state of the element when it is visible.
                state('in', style({ opacity: 1 })),

                // fade in when created. this could also be written as transition('void => *')
                transition(':enter', [
                    style({ opacity: 0 }),
                    animate(1600)
                ])
                // fade out when destroyed. this could also be written as transition('void => *')

            ]),
            trigger('visibilityChanged',
                [
                    state('visible', style({ left: '0' })),
                    state('hidden', style({ left: '-400px' })),
                    state('void', style({ left: '-400px' })),
                    transition('visible => hidden', animate(300)),
                    transition('hidden => visible', animate(300)),
                    transition('void => visible', animate(300))
                ]),
        ]
})
export class ClaimReward implements OnInit, OnDestroy {

    public _reward: string;
    public _rewardDesc: string;
    public _emotion: string;
    public _time: any;
    public _errorMessage: string;
    public _customerID: any;
    public _claimData: claimRewards;
    public _dataSet: any;
    public _labelSet: any;
    public _lables: any;
    public _customerData: any;
    templateData: string = 'Loading emotions...';
    _status: number = 0;
    color: string = 'first';
    font: string = 'one';
    state: string = "in";
    rotate: string = "rotated";
    yourImage = new Image();
    title = 'testapp';
    emoji = ['happy', 'angry', 'getting_angry', 'furious', 'ok', 'last'];
    myEmojis = [];
    public lineChartColors: Array<any> = [];
    public lineChartLegend: boolean = true;
    public lineChartType: string = 'line';
    public lineChartData: Array<any> = [];
    public lineChartLabels: Array<any> = ['January', 'February', 'March', 'April', 'May', 'June'];

    private lineChartOptions: any = {
        responsive: true,
        legend: {
            display: false
        },
        scales: {
            xAxes: [{
                gridLines: {
                    drawOnChartArea: false,
                    drawBorder: false,
                    // labelWrap: true, 
                    // labelAutoFit: true
                },
                ticks: {
                    fontColor: "white",
                    fontSize: 16,
                    // labelWrap: true, 
                    // labelAutoFit: true,

                }
            }],
            yAxes: [{
                gridLines: {
                    drawOnChartArea: false,
                    drawBorder: false,
                },
                ticks: {
                    display: false,
                    fontColor: "white",
                }
            }],
        }
    };


    constructor(private _globalService: GlobalService, private spinnerService: Ng4LoadingSpinnerService, private _formBuilder: FormBuilder, private _rewardDataService: rewardDataService, private _router: Router,
        private _activatedRoute: ActivatedRoute, ) {
        for (let i in this.emoji) {
            if (this.emoji[i] == 'happy') {
                this.yourImage.src = "../../assets/happy.png";
                this.myEmojis.push(this.yourImage);
            } else if (this.emoji[i] == 'angry') {
                this.yourImage = new Image();
                this.yourImage.src = "../../assets/Angry.png";
                this.myEmojis.push(this.yourImage);
            } else if (this.emoji[i] == 'getting_angry') {
                this.yourImage = new Image();
                this.yourImage.src = "../../assets/getting_angry.png";
                this.myEmojis.push(this.yourImage);
            } else if (this.emoji[i] == 'furious') {
                this.yourImage = new Image();
                this.yourImage.src = "../../assets/furious.png";
                this.myEmojis.push(this.yourImage);
            } else if (this.emoji[i] == 'ok') {
                this.yourImage = new Image();
                this.yourImage.src = "../../assets/sad.png";
                this.myEmojis.push(this.yourImage);
            } else if (this.emoji[i] == 'last') {
                this.yourImage = new Image();
                this.yourImage.src = "../../assets/furious.png";
                this.myEmojis.push(this.yourImage);
            }
        }
        console.log(this.myEmojis)

        this.lineChartColors = [
            {
                borderColor: '#FFB200',
                pointBackgroundColor: 'white',
                pointBorderColor: 'white',
                pointHoverBackgroundColor: '#fff',
                pointStyle: this.myEmojis,
                fill: false,
                borderWidth: 4,
            },
        ];
    }

    public ngOnInit() {
        debugger
        if (this._globalService.isEmpty(this._globalService.data)) {
            this._router.navigate(['/']);
        }
        else {
            // this._resetFormErrors();
            this.testInterval();
            this._resetOtp();
            this.state = (this.state === 'default' ? 'rotated' : 'default');
debugger
            this._activatedRoute.params.subscribe(params => {

                this._customerID = this._globalService.customerID;

                console.log("labelGobal::", this._globalService.data);
                this._customerData = this._globalService.data.customerData;
                this._dataSet = this._globalService.data.dataSet;
                //this._labelSet = this._globalService.data.labels;
                this._reward = this._globalService.data.customerData.reward;
                this._rewardDesc = this._globalService.data.customerData.reward_desc;
                this._emotion = this._globalService.data.customerData.smiley_emotion;
                this._time = this._globalService.data.customerData.time;
                console.log("Data:::", this._customerData, this._dataSet, this._labelSet);

                this.lineChartData = [
                    { data: this._dataSet, label: '', backgroundColor: "rgba(151,187,205,0.5)", },
                ];

                console.log("loopData::", this.lineChartLabels);
                console.log('dataset', this._dataSet);
            });
        }
    }

    testInterval() {
        let timeInterval = setInterval(() => {
            this._status += 10;
            if (this._status == 20) {
                clearInterval(timeInterval);
            } else {
                this.templateData = 'Calculating internet mood...';
            }
        }, 3000);
    }

    public randomize(): void {
        let _lineChartData: Array<any> = new Array(this.lineChartData.length);
        for (let i = 0; i < this.lineChartData.length; i++) {
            _lineChartData[i] = { data: new Array(this.lineChartData[i].data.length), label: this.lineChartData[i].label };
            for (let j = 0; j < this.lineChartData[i].data.length; j++) {
                _lineChartData[i].data[j] = Math.floor((Math.random() * 100) + 1);
            }
        }
        this.lineChartData = _lineChartData;
    }

    // events
    public chartClicked(e: any): void {
        console.log("clicked");
    }

    public chartHovered(e: any): void {
        console.log(e);
        //    this.yourImage.src = "../../assets/furious2.png";
    }

    private _resetOtp() {
        this._claimData = new claimRewards();
        this._claimData.customer_id = '';
    }

    public onSubmit() {
        this.spinnerService.show();
        this._claimData.customer_id = this._customerID;
        this._claimData.campaign_id = 1;

        this._rewardDataService.submitdetails(this._claimData)
            .subscribe(
                result => {
                    if (result) {
                        this.spinnerService.hide();
                        console.log("Data Sent::", result);
                        this._globalService.data = {};
                        this._router.navigate(['/thankYou']);

                    } else {
                        //this._tab1Submitted = false;
                    }
                },
                error => {
                    // this._tab1Submitted = false;
                    // Validation errors
                    if (error.status == 422) {
                        let errorFields = JSON.parse(error.data.message);
                        //  this._setFormErrors(errorFields);
                    }
                    // Unauthorized Access
                    else if (error.status == 401 || error.status == 403) {
                        // this._staffService.unauthorizedAccess(error);
                    }
                    // All other errors
                    else {
                        this._errorMessage = error.data.message;
                    }
                }
            );
    }

    public ngOnDestroy() {
        this._globalService.data = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/claimReward/claimReward.ts